export class AuthenticationFactorChoice {
  constructor (
    public factorType: string,
    public factorID: string,
    public value: string,
    public sequence: number
  ) { }
}
